import React, { useEffect, useRef, useState } from "react";
import { Container, Image } from "react-bootstrap";
import { uploadFile } from "../../redux/actions/translateAction";
import { useDispatch } from "react-redux";
import useDrivePicker from "react-google-drive-picker";
import "./translations.css";
import TranslationPage from "./translationPage";
import errorToast from "../../components/toast/errorToast";
import { pdfjs } from 'react-pdf';
import mammoth from 'mammoth';
import JSZip, { files } from "jszip";
import TranslationLayout from "../../components/ui/layouts/translate-layout";
import { googleClientId } from "../../redux/config";
import { useNavigate } from "react-router-dom";
import GoogleDrivePicker from "../../components/buttons/googleDrive";
import pdfIcon from "../../assets/icons/pdf-icon.svg";
import pptxIcon from "../../assets/icons/pptx-icon.svg";
import docxIcon from "../../assets/icons/docx-icon.svg";
import htmlIcon from "../../assets/icons/html-icon.webp";
import LoaderModal from "../../components/ui/Modal/loaderModal";
import { useAuth } from '../../context/AuthContext';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function Translations() {

  const [openPicker] = useDrivePicker();
  const dispatch = useDispatch();
  const [fileSelected, setFileSelected] = useState(false);
  const [fileUploadedData, setFileUploadedData] = useState({});
  const [numPages, setNumPages] = useState(0);
  const [fileType, setFileType] = useState('');
  const pageCountRef = useRef(0);
  const { isDemo, portalId } = useAuth();
  const [token, setAccessToken] = useState(null)
  const accessToken = localStorage.getItem('driveAccessToken') || null;
  const [showLoader, setShowLoader] = useState(false)

  function calculatePages(wordCount) {
    const wordsPerPage = 300;
    const totalPages = Math.ceil(wordCount / wordsPerPage);
    return totalPages;
  }

  const A4_PAGE_HEIGHT = 1122; // in pixels for 96dpi screen

  const getHTMLPageCount = async (htmlFile) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const htmlContent = e.target.result;

      const iframe = document.createElement('iframe');
      iframe.style.visibility = 'hidden';
      iframe.style.height = '0';
      iframe.style.width = '0';
      document.body.appendChild(iframe);

      iframe.contentDocument.open();
      iframe.contentDocument.write(htmlContent);
      iframe.contentDocument.close();

      iframe.onload = () => {
        const contentHeight = iframe.contentDocument.body.scrollHeight;
        const totalPages = Math.ceil(contentHeight / A4_PAGE_HEIGHT);

        console.log('Estimated pages:', totalPages);
        pageCountRef.current = totalPages;
        setNumPages(totalPages);

        document.body.removeChild(iframe);
      };
    };

    reader.readAsText(htmlFile);
  };

  const acceptableFormats = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.google-apps.document", "text/html"]

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    console.log("The file data is", file);
    const fileType = file.type;
    console.log("fileType", fileType);

    if (!acceptableFormats.includes(fileType)) {
      errorToast("Supported file formats are PPTX, DOCX, and PDF only.");
    } else {
      setShowLoader(true)
      if (fileType === "application/pdf") {
        setFileType('pdf');
        const reader = new FileReader();
        reader.onload = async (e) => {
          const arrayBuffer = e.target.result;
          try {
            const doc = await pdfjs.getDocument({ data: arrayBuffer, isEvalSupported: false }).promise;
            const numPages = doc.numPages;
            console.log("Number of pages is", numPages);
            setNumPages(numPages);
            pageCountRef.current = numPages;
            processFile(file);
          } catch (error) {
            console.error("Error loading the document:", error);
            if (error.name === 'PasswordException') {
              errorToast("Password-protected PDFs are not supported. Please upload an unlocked PDF.");
            } else {
              errorToast(error.message || "Failed to load the PDF document.");
            }
            setNumPages(0);
            setShowLoader(false);
            return;
          }
        };
        reader.readAsArrayBuffer(file);
      } else if (file && fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        const arrayBuffer = await file.arrayBuffer();
        const result = await mammoth.extractRawText({ arrayBuffer });
        const wordCount = result.value.split(/\s+/).length;
        console.log("Word count is", wordCount);
        const numPages = calculatePages(wordCount);
        console.log("Word count pages", numPages);
        pageCountRef.current = numPages;
        setNumPages(numPages);
        processFile(file);
      } else if (fileType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const arrayBuffer = e.target.result;
          try {
            const zip = await JSZip.loadAsync(arrayBuffer);
            const slides = zip.folder("ppt/slides/");
            let numSlides = 0;
            slides.forEach((relativePath, file) => {
              if (file.name.endsWith(".xml")) {
                numSlides++;
              }
            });
            setNumPages(numSlides);
            pageCountRef.current = numSlides;
            console.log("Number of slides is", numSlides);
            processFile(file);
          } catch (error) {
            console.error("Error loading the PowerPoint document:", error);
            setNumPages(0);
            setShowLoader(false);
            return;
          }
        };
        reader.readAsArrayBuffer(file);
      }
      else if (fileType === "text/html") {
        setFileType('html')
        await getHTMLPageCount(file)
        processFile(file);
      }
    }
  };

  const handleDriveFileChange = async (fileData) => {
    const fileType = fileData.mimeType;
    console.log(fileType, "khbhfkabbflkjanbfkabgfknbasfkbh");

    if (!acceptableFormats.includes(fileType)) {
      errorToast("Supported file formats are PPTX, DOCX, and PDF only.");
    } else {
      setShowLoader(true)
      try {
        const fileId = fileData.id;
        const fileUrl = `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;

        const response = await fetch(fileUrl, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${accessToken}`
          }
        });
        const arrayBuffer = await response.arrayBuffer();

        const blob = new Blob([arrayBuffer], { type: fileData.mimeType });
        const fileObject = new File([blob], fileData.name, { type: fileData.mimeType });

        if (fileType === "application/pdf") {
          setFileType('pdf');
          const doc = await pdfjs.getDocument({ data: arrayBuffer, isEvalSupported: false }).promise;
          const numPages = doc.numPages;
          setNumPages(numPages);
          pageCountRef.current = numPages;
          processFile(fileObject);
        } else if (fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
          const result = await mammoth.extractRawText({ arrayBuffer });
          const wordCount = result.value.split(/\s+/).length;
          console.log("Word count is", wordCount);
          const numPages = calculatePages(wordCount);
          console.log("Word count pages", numPages);
          pageCountRef.current = numPages;
          setNumPages(numPages);
          processFile(fileObject);
        } else if (fileType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
          const zip = await JSZip.loadAsync(arrayBuffer);
          const slides = zip.folder("ppt/slides/");
          let numSlides = 0;
          slides.forEach((relativePath, file) => {
            if (file.name.endsWith(".xml")) {
              numSlides++;
            }
          });
          setNumPages(numSlides);
          pageCountRef.current = numSlides;
          console.log("Number of slides is", numSlides);
          processFile(fileObject);
        }
        else if (fileType === "text/html") {
          setFileType('html')
          await getHTMLPageCount(fileObject)
          processFile(fileObject);
        }
        else {
          console.log("Unsupported file type:", fileType);
          setNumPages(0);
        }
      } catch (error) {
        console.error("Error processing the file:", error);
        setNumPages(0);
        setShowLoader(false);
        errorToast(error.message || "Failed to process the file. Please try again.");
      }
    }
  };

  const handleDriveFile = async (driveFile) => {
    try {
      handleDriveFileChange(driveFile);
    } catch (error) {
      console.error("Error fetching the file from Google Drive:", error);
    }
  };


  const processFile = (file) => {
    if (isDemo) {
      console.log("File uploaded demo", pageCountRef.current);
      if (pageCountRef.current > 15) {
        errorToast("File pages should be less than 15");
        setTimeout(() => {
          window.location.reload()
        }, 3000);
      } else {
        dispatch(uploadFile(file, onSuccess, onError));
      }
    } else {
      dispatch(uploadFile(file, onSuccess, onError));
    }
  };


  const onSuccess = (data) => {
    setFileSelected(true);
    setShowLoader(false)
    setFileUploadedData(data.data.data);
  };
  const onError = (data) => {
    errorToast(data.data.message);
    setTimeout(() => {
      window.location.reload()
    }, 5000);
  };


  const handleOpenPicker = () => {
    openPicker({
      clientId: googleClientId,
      developerKey: "AIzaSyAr1CJ3ztX4RHr5O9z5IHeNQ6cGNRAR4LY",
      viewId: "ALL",
      showUploadView: false,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      callbackFunction: (data) => {
        console.log(data, "skdbfsidhgib");
        if (data.action === "cancel") {
        }
        if (data.action === "picked") {
          const selectedFiles = data.docs;
          if (selectedFiles.length === 1) {
            const file = selectedFiles[0];
            handleDriveFile(file);
          } else {
            errorToast("Please select only one file.");
          }
        }
      },
    });
  };

  const navigate = useNavigate()

  useEffect(() => {
    if (localStorage.getItem('logout') === 'true') {
      navigate(`/login/${portalId}`)
    }
  }, [])


  return (
    <>
      {!fileSelected ? (
        <TranslationLayout>
          <Container className="uploading_div mb-1">
            <div className="w-100 d-flex flex-column gap-5 justify-content-center align-items-center">
              <div className="d-flex justify-content-center align-items-center">
                <Image
                  alt="logo"
                  // src={
                  //   "https://www.gstatic.com/translation_hub/images/pptx-icon.svg"
                  // }
                  src={pptxIcon}
                  width={70}
                  height={70}
                  className=""
                />
                <Image
                  alt="logo"
                  // src={
                  //   "https://www.gstatic.com/translation_hub/images/pdf-icon.svg"
                  // }
                  src={pdfIcon}
                  width={70}
                  height={70}
                  className=""
                />
                <Image
                  alt="logo"
                  // src={
                  //   "https://www.gstatic.com/translation_hub/images/docx-icon.svg"
                  // }
                  src={docxIcon}
                  width={70}
                  height={70}
                  className=""
                />
                <Image
                  alt="logo"
                  // src={
                  //   "https://www.gstatic.com/translation_hub/images/docx-icon.svg"
                  // }
                  src={htmlIcon}
                  width={70}
                  height={70}
                  className=""
                />
              </div>
              <div className="d-flex gap-2 w-100 justify-content-center align-items-center">
                <div className="d-flex gap-3">
                  <label for="fileInput" class="custom-file-upload fs_14 fw_400 fn_Roboto hover-effect">
                    Select Files
                  </label>
                  <input id="fileInput" type="file" name="file" style={{ display: " none" }} accept=".pdf, .doc, .docx, .pptx, .html" onChange={handleFileChange} />
                  <label className="mt-2">{fileUploadedData?.originalName}</label>
                </div>
                {accessToken &&
                  <label class="custom-file-upload fs_14 fw_400 fn_Roboto hover-effect" onClick={handleOpenPicker}>
                    Import From Google Drive
                  </label>
                }
                {!accessToken &&
                  <GoogleDrivePicker setAccessTokens={setAccessToken} />
                }
              </div>
            </div>
            <LoaderModal show={showLoader} handleClose={() => setShowLoader(!showLoader)} text="Loading preview..." />
          </Container>
        </TranslationLayout>
      ) : (
        <TranslationPage
          file={fileUploadedData.filePathUrl}
          fileType={fileType}
          fileUploadedData={fileUploadedData}
          numPages={numPages}
          onHide={() => setFileSelected(!fileSelected)}
        />
      )}
    </>
  );
}
